import { getHours, parse } from 'date-fns'

import { DateFormat } from 'types/global'
import { formatDatetime, parseDate } from 'utils/datetime'

import { MeridiemOptions, MeridiemType } from './types'
import { Meridiem, onTimeChangeParam } from './TimeInput'

export const meridiemOpts: MeridiemOptions = [
  { label: 'AM', value: 'AM' },
  { label: 'PM', value: 'PM' },
]

export const UtilDateFormat: DateFormat = 'yyyy-MM-dd'
export const UtilDatetimeFormat: DateFormat = 'yyyy-MM-dd HH:mm:ss'
const dateWithMeridiemFormat = 'yyyy-MM-dd h:mm a'

export const constructDateTimeValue = (parts: {
  date: Date | string
  time: string
  showTimeWithMeridiem?: boolean
}) => {
  const { date, time, showTimeWithMeridiem = false } = parts
  const startDate = formatDatetime(date, UtilDateFormat)

  if (startDate) {
    if (showTimeWithMeridiem) {
      return parse(`${startDate} ${time}`, dateWithMeridiemFormat, new Date())
    }
    return parseDate(`${startDate} ${time}`)
  }

  return typeof date === 'string' ? parseDate(date) : date
}

export const isAfternoon = (value: Date) => getHours(value) >= 12

export const TWELVE_HOURS = 12 * 60 * 60 * 1000

export const getDefaultMeridiem = (date: Date | string | undefined | null): MeridiemType => {
  if (!date) {
    return 'AM'
  }

  const temp = typeof date === 'string' ? new Date(date) : date
  return isAfternoon(temp) ? 'PM' : 'AM'
}

export const convertToContinentalTime = ({ hours, meridiem }: onTimeChangeParam) => ({
  modifiedHours: hours % 12 || 12,
  modifiedMeridiem: hours > 12 && hours < 24 ? 'PM' : meridiem ? meridiem : 'AM',
})

export const formateTime = (inputValue: string) => {
  const [time, meridiem]: [string, Meridiem] = inputValue.split(' ') as [string, Meridiem]
  const [hours, minutes] = time.split(':')

  return { hours, minutes, numHours: Number(hours), numMinutes: Number(minutes || 0), meridiem, time, inputValue }
}
